module.exports = require('./PageScene');



/** WEBPACK FOOTER **
 ** ./demo/src/pages/scene/index.js
 **/